export const ExportType = {
    CSV_FILE: "CSV_FILE",
    DATEV_UO: "DATEV_UO",
    XML_FILE: "XML_FILE",
    NAVISION: "NAVISION",
    SAP: "SAP",
    DUPLICATES: "DUPLICATES",
    AVM_CUSTOM: "AVM_CUSTOM",
};

export const ExportFormat = {
    STANDARD: "STANDARD",
    EXTF_12: "EXTF_12",
    EXTF_9: "EXTF_9",
    BMD: "BMD",

    // Custom solution for a specific customer
    BEURER_EUROPE: "BEURER_EUROPE",
    // Used by Interhyp/ThinkImmo
    NAVISION: "NAVISION",
    SAP: "SAP",
    // Used by AVM
    AVM_CUSTOM: "AVM_CUSTOM",
};
